import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
render(<App data-id="element-514" data-mp="1wabdv094jilh" />, document.getElementById('root'));